"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Cad3d_1 = __importDefault(require("./Cad3d"));
exports.default = Cad3d_1.default;
